import colors from 'utils/colors'

export default {
  lightBackground: `
    background-color: ${colors.lightBlue};
    padding: 10px;
  `,
  bigNum: `
    & span {
      // font-size: 12px;
    }
    & .big-num {
      display: block;
      font-size: 23px;
    }
    &.grand {
      & span {
        font-size: 26px;
      }
      & .big-num {
        display: block;
        font-size: 36px;
      }
    }
  `,
  card: `
    border: 1px solid ${colors.grey};
    box-shadow: 0px 2px 4px rgba(0,0,0,.25);
    padding: 26px;
    margin-bottom: 25px;
    `,
  }
  // border-radius: 4px;